import { DOCUMENT } from "@angular/common";
import { Component, OnDestroy, OnInit, inject, signal } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { Subscription } from "rxjs";
import { SEO_STATIC_PAGES, type SeoSlug, canonicalUrl } from "./seo-static-page.meta";
import { setCanonicalLink } from "./seo-utils";

@Component({
  selector: "app-seo-static-page",
  standalone: true,
  imports: [RouterLink],
  templateUrl: "./seo-static-page.component.html",
})
export class SeoStaticPageComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly doc = inject(DOCUMENT);

  slug = signal<SeoSlug | null>(null);
  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.route.data.subscribe((d) => {
      const s = d["slug"] as SeoSlug;
      this.slug.set(s);
      this.applySeo(s);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private applySeo(slug: SeoSlug): void {
    const cfg = SEO_STATIC_PAGES[slug];
    if (!cfg) return;
    this.title.setTitle(cfg.title);
    this.meta.updateTag({ name: "description", content: cfg.description });
    this.meta.updateTag({ property: "og:title", content: cfg.ogTitle });
    this.meta.updateTag({ property: "og:description", content: cfg.ogDescription });
    this.meta.updateTag({ property: "og:url", content: canonicalUrl(cfg.path) });
    setCanonicalLink(this.doc, canonicalUrl(cfg.path));
    this.doc.documentElement.lang = slug.endsWith("-es") ? "es" : slug.endsWith("-en") ? "en" : "pt-BR";
  }
}
